'use client';

import { FooterLegalPolicies } from '@/types/legal-policies';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';

class PolicyPagesApiService {
  private readonly policyPagesUrl = '/papi/legal-policies';

  async getFooterPolicyPages(signal?: AbortSignal): Promise<CommonFetchResponse<FooterLegalPolicies>> {
    return await commonFetch<FooterLegalPolicies>(this.policyPagesUrl, signal ? { signal } : undefined);
  }
}

export const policyPagesApiService = new PolicyPagesApiService();
